/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
import { ITemplate } from "@Templates/ITemplate";
import { SECTION_IDS, CurvedArrowSvg, MEDIA } from "@Utils";
import { classNames } from "repoV2/utils/common/render/classNames";
import { ButtonV2 } from "@Modules/common/ButtonV2";
import styles from "../AboutUs/aboutUs.module.scss";
import commonStyles from "../../../yoga/root/yoga.module.scss";

// TODO - @aditya: use it in AboutUs in phase2
const AboutCover = ({
    coverImg,
    title,
    shortDescription,
    getInTouchCtaText,
    onGetInTouchClick,
    hideGetInTouch,
}: ITemplate.IAboutSectionProps): JSX.Element => {
    const showOverlay = title || shortDescription || !hideGetInTouch;
    return (
        <section>
            <a id={SECTION_IDS.about} className={commonStyles.sectionAnchor} />
            <div
                className={styles.heroSection}
                style={{
                    backgroundImage: `url(${
                        coverImg || MEDIA.DEFAULT.BACKGROUND.EDUVERSE
                    })${
                        showOverlay
                            ? ",linear-gradient(rgba(31, 31, 31, 0.85), rgba(31, 31, 31, 0.65))"
                            : ""
                    }`,
                }}
            >
                <div className={styles.heroContent}>
                    {title ? <h1 className={styles.title}>{title}</h1> : null}
                    {shortDescription ? (
                        <p
                            className={classNames(
                                styles.shortDescription,
                                styles.desktopOnly
                            )}
                        >
                            {shortDescription}
                        </p>
                    ) : null}
                    {hideGetInTouch ? null : (
                        <div className={styles.bannerCtaContainer}>
                            <ButtonV2
                                applyTheme
                                onClick={() => {
                                    onGetInTouchClick();
                                }}
                                className={styles.bannerCta}
                            >
                                {getInTouchCtaText}
                            </ButtonV2>
                            <div className={styles.heroCtaArrow}>
                                <CurvedArrowSvg
                                    className={styles.arrowIcon}
                                    stroke="#fff"
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default AboutCover;
